export const meetupDate = '2025-09-18';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'ai-and-china-roadshow-2025-munich';

export const initialCoordinates = {
  lat: 48.196438045582504,
  lng: 11.60678305444265,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'Mobility, AI, and Trade War: Lessons From China',
  address: 'Highline, Am Ausbesserungswerk 8, Motorworld, 80939 München',
  link: 'https://maps.app.goo.gl/Axv6pM7A2pn6bQjM6',
};
